import { EDITORS_CONFIG, VIEWERS_CONFIG } from 'reactApp/appHelpers/configHelpers';
import { put } from 'redux-saga/effects';

import { composeAvailableEditors, composeExtensions, composeSharedExtensions } from './editor.helpers';
import { initEditor } from './editor.module';
import type { RawEditor } from './editor.types';

export function* setEditor() {
    const editors: RawEditor[] = EDITORS_CONFIG.length ? EDITORS_CONFIG : VIEWERS_CONFIG;
    const extensions = composeExtensions(editors);
    const availableEditors = composeAvailableEditors(editors, extensions);
    const hasSharedEditor = editors.some((editor) => 'x-in-shared-folder' in editor);
    const sharedExtensions = composeSharedExtensions(editors, extensions);

    yield put(initEditor({ availableEditors, hasSharedEditor, sharedExtensions, extensions }));
}
